import LaravelRoutes from '@/router/LaravelRoutes';

export default class Route {
    /**
     * Get the URL for the given route name.
     *
     * @param {string} name
     * @param {object} params
     * @returns {string}
     */
    static route(name, params = {}) {
        let url = LaravelRoutes[name] || name;
        for (let key in params) {
            url = url.replace('{' + key + '}', params[key]);
        }
        return url;
    }

    /**
     * Get the URL for the given route name without the /api prefix.
     * This is useful when used with the API service because it already has the /api prefix.
     *
     * @param {string} name
     * @param {object} params
     * @returns {string}
     */
    static routeWithoutApiPrefix(name, params = {}) {
        let url = this.route(name, params);
        return url.replace(/\/*api/, '');
    }

    /**
     * Check if the given route name exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    static has(name) {
        return LaravelRoutes[name] ? true : false;
    }

    /**
     * Get the route name for the given URL.
     *
     * @param {string} url
     * @returns {string}
     */
    static find(url) {
        // Check if we're given a full URL and convert it to a relative URL
        url = url.replace(window.location.origin, '');

        // Find the route name for the given URL
        for (let name in LaravelRoutes) {
            let route = LaravelRoutes[name];
            let pattern = route.replace(/{\w+}/g, '\\w+');
            if (new RegExp('^' + pattern + '$').test(url)) {
                return name;
            }
        }
        return null;
    }

}
